module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/talle/talle.component.html
// module id = ./src/app/productos/talle/talle.component.html
// module chunks = main